import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <Box
      dir={direction}
      sx={{
        height: "100vh",
        backgroundImage: 'url(/image/About1.jpg)', // use / for public assets
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        color: "white",
        borderRadius: "50px",
        m: 3,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(36, 36, 36, 0.6)",
          borderRadius: "50px",
          zIndex: 1,
        }}
      />
      <Box sx={{ zIndex: 2, px: 2 }}>
        <Typography variant="h2" fontWeight="bold" mb={2}>
          {t("hero.title")}
        </Typography>
        <Typography variant="h5" mb={4}>
          {t("hero.subtitle")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          component={Link}
          to="/project"
        >
          {t("hero.button")}
        </Button>
      </Box>
    </Box>
  );
};

export default HeroSection;
